<template>
  <div id="webPageTrans">
    <y-d-f-y-tab-bar :webPageTrans="webPageTrans" ref="searchBar" :userTurnUrl="userTurnUrl"/>
    <div class="url_is_null" v-if="urlNull">
      <p>抱歉：</p>
      <p>您所输入的链接为空，请正确输入链接，或<a href="http://fanyi.youdao.com/"> 返回上一级</a>。</p>
    </div>
    <div class="url_is_no" v-if="urlNo">
      <p>很抱歉，您输入的网址不存在或当前无法访问，请稍后重试<br/>{{userInputUrl}}</p>
      <p><a href="https://fanyi.youdao.com/">返回上一页</a></p>
    </div>
    <div class="loading" v-show="isLoading">
      <img src="https://shared-https.ydstatic.com/dict/market/webTransPc/images/loading.gif" alt="">
      <p>翻译中…</p>
    </div>
    <div class="iframe_contact" v-show="!urlNull && !urlNo && !isLoading">
      <iframe :src="iframeUrl" name="iframe" ref="iframe" id="iframe" sandbox="allow-scripts allow-same-origin allow-popups allow-forms"></iframe>
    </div>
  </div>
</template>

<script>
import YDFYTabBar from "./../components/YDFYTabBar";
import { checkLink, getParameter } from "./../libs/utils.js";

export default {
  name: "WebPageTrans",
  data() {
    return {
      iframeUrl: '',
      webPageTrans: true,
      userInputUrl: '',
      iframeHeight: "",
      urlNull: true,
      userTurnUrl: '',
      urlNo: false,
      isLoading: false
    };
  },
  mounted() {
    let that = this
    if (typeof window.postMessage != "undefined") {
      // 检查浏览器是否支持postMessage
      let reciever = function(e) {
        ////监听到事件之后的回调
        let data = typeof e.data == 'string' && that.isJsonString(e.data) ? JSON.parse(e.data) : e.data
        if (data.goBack) {
          window.location.href = 'http://fanyi.youdao.com/'
        }
        if (data.newUrl) {
          let iframeUrl = decodeURIComponent(getParameter("url"))
          if (data.newUrl != iframeUrl && data.newUrl != '') {
            let from = getParameter("from");
            let to = getParameter("to");
            let type = getParameter("type");
            that.userTurnUrl = data.newUrl
          }
        }
      };
      if (window.addEventListener) {
        //兼容监听绑定事件---addEventListener：不带on
        window.addEventListener("message", reciever, false);
      } else if (window.attachEvent) {
        window.attachEvent("onmessage", reciever);
      }
    }
    this.trans()
    // this.$nextTick(() => {
      // let winHeight;
      // if (window.innerHeight) winHeight = window.innerHeight;
      // else if (document.body && document.body.clientHeight)
        // winHeight = document.body.clientHeight;
      // this.iframeHeight = winHeight - 72 + "px";
    // });
  },
  watch: {
    '$route': function () {
      this.trans()
    }
  },
  methods: {
    resetStatus() {
      this.urlNull = false
      this.urlNo = false
      this.isLoading = false
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
            return true;
        }
      } catch(e) {
        return false;
      }
    },
    trans() {
      let searchUrl = decodeURIComponent(getParameter("url"))
      let from = getParameter("from");
      let to = getParameter("to");
      let type = getParameter("type");
      this.userInputUrl = searchUrl
      if (searchUrl == '' || searchUrl == undefined || null) {
        this.resetStatus()
        this.urlNull = true
      } else {
        if (searchUrl.substring(0, 4) != "http") {
          searchUrl = `http://${searchUrl}`;
        }
        if (!checkLink(searchUrl)) {
          this.resetStatus()
          this.urlNo = true
        } else {
          this.resetStatus()
          this.isLoading = true
          let product = "mdictweb";
          let salt = new Date().getTime();
          let secretKey = "ydsecret://mdictweb.si/sign/-eV=8}L$s4$nPL00op3p]";
          let content = searchUrl;
          let signData = `${product}${salt}${secretKey}${content}`;
          let sign = this.$md5(signData); // md5加密
          this.resetStatus()
          let transUrl = `http://webtrans.yodao.com/server/webtrans/tranUrl?url=${encodeURIComponent(searchUrl)}&from=${from}&to=${to}&type=${type}&product=mdictweb&salt=${salt}&sign=${sign}`;
          // let transUrl = `http://fanyi-test.youdao.com/server/webtrans/tranUrl?url=${encodeURIComponent(searchUrl)}&from=${from}&to=${to}&type=${type}&product=mdictweb&salt=${salt}&sign=${sign}&invalid=true`
          this.iframeUrl = transUrl
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      this.$router.push({path: '/wap'});
    }
    next()
  },
  components: {
    YDFYTabBar
  }
};
</script>

<style scoped>
#webPageTrans {
  width: 100%;
  height:100%;
  position: fixed;
}
.url_is_null,
.url_is_no,
.loading {
  padding-top: 121px;
}
.url_is_null,
.url_is_no,
.loading,
.time_out {
  max-width: 1440px;
  min-width: 1106px;
  margin: 0 auto;
}
.url_is_null p,
.url_is_no p {
  font-size: 24px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
  margin: 0 0 24px 240px;
}
.url_is_null a,
.url_is_no a {
  color: rgba(1, 122, 255, 1);
}
.loading img {
  width: 55px;
  height: 58px;
  margin: 0 auto 36px;
  background: rgba(102, 102, 102, 1);
}
.loading p {
  width: 100%;
  height: 45px;
  font-size: 32px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 45px;
  text-align: center;
}
.time_out {
  padding-top: 262px;
}
.time_out h5 {
  width: 100%;
  height: 45px;
  font-size: 32px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  line-height: 45px;
  margin: 0 auto 15px;
  text-align: center;
}
.time_out span {
  width: 100%;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
  display: block;
  margin: 0 auto 48px;
}
.time_out button {
  width: 82px;
  height: 40px;
  border-radius: 3px;
  border: 1px solid rgba(230, 230, 230, 1);
  display: block;
  margin: 0 auto;
  font-size: 16px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(224, 36, 51, 1);
  line-height: 22px;
}
.iframe_contact {
  position: absolute;
  width: 100%;
  top: 72px;
  bottom: 0;
}
.iframe_contact iframe {
  width: 100%;
  height:100%;
}
</style>
